import styled from "styled-components";
import { breakpoint } from "styles/mixins";

export const DropDownWrapper = styled.div`
  position: relative;
`;

export const DropDownButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 134px;
  background-color: white;
  height: 38px;
  border: 1px solid #e5e5ea;
  border-radius: 38px;
  font-size: 14px;
  white-space: nowrap;
  color: #333333;
  box-shadow: ${(p) =>
    p.actionDropDown ? "0px 2px 8px 0px rgba(0, 0, 0, 0.3)" : ""};
  &:hover {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.3);
  }
`;

export const SVG = styled.svg`
  margin-right: 8px;
  height: 1rem;
  width: 1.2rem;
`;

export const OptionMenu = styled.div`
  transform-origin: top bottom;
  position: absolute;
  left: 3px;
  top: 16px;
  background-color: white;
  width: 287px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 1px 1px 8px 0px rgba(0, 0, 0, 0.25);
  padding: 24px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  .unicode-plain {
    unicode-bidi: plaintext;
  }
  .price-holder {
    text-align: center;
    font-size: 16px;
  }

  ${breakpoint.lessThan("tablet")`
    width: min-content;
    flex-direction: row;
    margin:auto;
    padding: 16px 12px;
    gap: 12px;
    .price-holder {
    font-size: 14px;
    white-space: nowrap;
  }
  `}
`;

export const OptionRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-items: center;
  width: 239px;
  height: 94px;
  padding: 22px 34px;
  background-color: #f5f5f7;
  border-radius: 16px;
  text-align: center;
  ${breakpoint.lessThan("tablet")`
    width: 95%;
    margin: auto;
    padding: 8px;
  `}
`;

export const Label = styled.label`
  // position: relative;
  display: inline;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
  font-weight: 700;
  color: #222;
  span {
    display: flex;
  }
  white-space: nowrap;
  ${breakpoint.lessThan("tablet")`
    font-size: 12px;
  `}

  svg {
    cursor: pointer;
  }
  [title] {
    // position: relative;
    display: flex;
    justify-content: center;
  }
  @media (pointer: coarse), (hover: none) {
    [title]:focus::after {
      content: attr(title);
      position: absolute;
      top: 47%;
      left: 1%;
      color: #fff;
      background-color: #222;
      border: 1px solid;
      width: 93%;
      padding: 4px 8px;
      z-index: 9999999999;
      border-radius: 4px;
    }
  }
`;
